module.exports = __webpack_public_path__ + "media/images/team/andy_piggott-c7d8404b96df200c5cfaf701ce0a502e.png";